import { h, Host } from "@stencil/core";
export class ButtonVideoModal {
    clickHandler() {
        if (!this.src || document.body.classList.contains('modal-open')) {
            return;
        }
        const modalElement = document.createElement('video-modal');
        Object.assign(modalElement, {
            src: this.src
        });
        document.body.appendChild(modalElement);
    }
    render() {
        return (h(Host, { key: '2f9e37577fd16fb387f30b33a11e2c526003acba', role: "button" }, h("slot", { key: '4d372652b60ccdeb85cec2706510690c2ba41d3e' }), h("svg", { key: '5e7a82b1b43cbbe6298ea22d53e42c0e8b6a8ab5', xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 1792 1792", fill: "#000" }, h("path", { key: '1a2c05e91f8c031336213d06ee0b57271cd3c32f', d: "M1576 927L248 1665q-23 13-39.5 3t-16.5-36V160q0-26 16.5-36t39.5 3l1328 738q23 13 23 31t-23 31z" }))));
    }
    static get is() { return "button-video-modal"; }
    static get originalStyleUrls() {
        return {
            "$": ["./button-video-modal.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["button-video-modal.css"]
        };
    }
    static get properties() {
        return {
            "src": {
                "type": "string",
                "attribute": "src",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "reflect": false
            }
        };
    }
    static get elementRef() { return "el"; }
    static get listeners() {
        return [{
                "name": "click",
                "method": "clickHandler",
                "target": undefined,
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=button-video-modal.js.map
